import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { UiComponentsModule } from 'src/app/shared/ui-components/ui-components.module';
import { HeaderComponent } from './header/header.component';
import { IndustriesFooterComponent } from './industries-footer/industries-footer.component';
import { IndustryCardComponent } from './industry-card/industry-card.component';
import { IndustryLeftCardComponent } from './industry-card/industry-left-card.component';
import { IndustryRightCardComponent } from './industry-card/industry-right-card.component';
import { InfoCardComponent } from './info-card/info-card.component';
import { TransportLayoutComponent } from './transport-layout/transport-layout.component';

@NgModule({
  declarations: [
    IndustryLeftCardComponent,
    IndustryRightCardComponent,
    IndustriesFooterComponent,
    HeaderComponent,
    IndustryCardComponent,
    InfoCardComponent,
    TransportLayoutComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    UiComponentsModule,
    DirectivesModule
  ],
  exports:[IndustryLeftCardComponent,IndustryRightCardComponent,IndustriesFooterComponent,HeaderComponent,IndustryCardComponent,InfoCardComponent,TransportLayoutComponent
  ]
})
export class IndustryComponentsModule { }
